import { Button } from "primereact/button";
import React from "react";
import { MainCard } from "../../../components/Card/Cards";
import { useNavigate } from "react-router-dom";

export default function Success() {
  const navigate = useNavigate();
  return (
    <MainCard size="md:w-5 w-full text-center">
      <h2>You have successfully submitted Drive Application form.</h2>
      <h2>Thanks</h2>
      <Button label="Home Page" onClick={() => navigate("/")} />
    </MainCard>
  );
}
